import React from "react";
import { Chart, ChartArea, ChartLegend, ChartSeries, ChartSeriesItem, ChartTooltip, ChartXAxis, ChartXAxisItem, ChartYAxis, ChartYAxisItem } from "@progress/kendo-react-charts";

interface EfficiencyCurveProps {
    chart2Data?: any;
}

const HeadCurve: React.FC<EfficiencyCurveProps> = ({ chart2Data }) => {
    return (
        <div>
            {chart2Data && (
                <Chart>
                    <ChartArea background="transparent" />

                    {/* Legend */}
                    <ChartLegend
                        position="bottom"
                        labels={{ font: "16px Mulish", color: "#fff" }}
                    />

                    {/* Series */}
                    <ChartSeries>
                        <ChartSeriesItem
                            name="45 Hz"
                            type="scatterLine"
                            data={chart2Data?.series?.[0]?.data}
                            xField="capacity"
                            yField="head"
                            color="#0000FF"
                            yAxis="Head"
                            style="smooth"
                            markers={{ visible: false }}
                            width={4.0}
                            tooltip={{ visible: true, format: "{0} x {1}", color: "#FFF" }}
                        />
                        <ChartSeriesItem
                            name="50 Hz"
                            type="scatterLine"
                            data={chart2Data?.series?.[1]?.data}
                            xField="capacity"
                            yField="power"
                            color="#0000FF"
                            yAxis="Head"
                            style="smooth"
                            markers={{ visible: false }}
                            width={4.0}
                            tooltip={{ visible: false, format: "{0} x {1}", color: "#FFF" }}
                        />
                        <ChartSeriesItem
                            name="55 Hz"
                            type="scatterLine"
                            data={chart2Data?.series?.[2]?.data}
                            xField="capacity"
                            yField="efficiency"
                            color="#0000FF"
                            yAxis="Head"
                            style="smooth"
                            markers={{ visible: false }}
                            width={4.0}
                            tooltip={{ visible: true, format: "{0} x {1}", color: "#FFF" }}
                        />
                        <ChartSeriesItem
                            name="60 Hz"
                            type="scatterLine"
                            data={chart2Data?.series?.[3]?.data}
                            xField="capacity"
                            yField="efficiency"
                            color="#0000FF"
                            yAxis="Head"
                            style="smooth"
                            markers={{ visible: false }}
                            width={4.0}
                            tooltip={{ visible: true, format: "{0} x {1}", color: "#FFF" }}
                        />
                        <ChartSeriesItem
                            name="65 Hz"
                            type="scatterLine"
                            data={chart2Data?.series?.[4]?.data}
                            xField="capacity"
                            yField="efficiency"
                            color="#0000FF"
                            yAxis="Head"
                            style="smooth"
                            markers={{ visible: false }}
                            width={4.0}
                            tooltip={{ visible: true, format: "{0} x {1}", color: "#FFF" }}
                        />
                        <ChartSeriesItem
                            name="70 Hz"
                            type="scatterLine"
                            data={chart2Data?.series?.[5]?.data}
                            xField="capacity"
                            yField="efficiency"
                            color="#0000FF"
                            yAxis="Head"
                            style="smooth"
                            markers={{ visible: false }}
                            width={4.0}
                            tooltip={{ visible: true, format: "{0} x {1}", color: "#FFF" }}
                        />
                        <ChartSeriesItem
                            name="75 Hz"
                            type="scatterLine"
                            data={chart2Data?.series?.[6]?.data}
                            xField="capacity"
                            yField="efficiency"
                            color="#0000FF"
                            yAxis="Head"
                            style="smooth"
                            markers={{ visible: false }}
                            width={4.0}
                            tooltip={{ visible: true, format: "{0} x {1}", color: "#FFF" }}
                        />
                        <ChartSeriesItem
                            name="Min"
                            type="scatterLine"
                            dashType="longDash"
                            data={chart2Data?.series?.[7]?.data}
                            xField="capacity"
                            yField="head"
                            color="#737373"
                            yAxis="Head"
                            markers={{
                                visible: false,
                                type: "square",
                                background: "black",
                                size: 10,
                            }}
                            width={2.0}
                            labels={{
                                visible: false,
                                background: "#bfbfbf",
                                border: {
                                    width: 1,
                                    color: "black",
                                },
                                font: "11px calibri",
                            }}
                            tooltip={{
                                visible: true,
                                format: "{0} x {1}",
                                color: "#FFF",
                            }}
                            visibleInLegend={false}
                        />
                        <ChartSeriesItem
                            name="Max"
                            type="scatterLine"
                            dashType="longDash"
                            data={chart2Data?.series?.[8]?.data}
                            xField="capacity"
                            yField="head"
                            color="#737373"
                            yAxis="Head"
                            markers={{
                                visible: false,
                                type: "square",
                                background: "black",
                                size: 10,
                            }}
                            width={2.0}
                            labels={{
                                visible: false,
                                background: "#bfbfbf",
                                border: {
                                    width: 1,
                                    color: "black",
                                },
                                font: "11px calibri",
                            }}
                            tooltip={{
                                visible: true,
                                format: "{0} x {1}",
                                color: "#FFF",
                            }}
                            visibleInLegend={false}
                        />
                        <ChartSeriesItem
                            name="BEP"
                            type="scatterLine"
                            dashType="longDash"
                            data={chart2Data?.series?.[9]?.data}
                            xField="capacity"
                            yField="head"
                            color="#0000FF"
                            yAxis="Head"
                            markers={{
                                visible: false,
                                type: "square",
                                background: "black",
                                size: 10,
                            }}
                            width={2.0}
                            labels={{
                                visible: false,
                                background: "#bfbfbf",
                                border: {
                                    width: 1,
                                    color: "black",
                                },
                                font: "11px calibri",
                            }}
                            tooltip={{
                                visible: true,
                                format: "{0} x {1}",
                                color: "#FFF",
                            }}
                            visibleInLegend={false}
                        />
                        <ChartSeriesItem
                            name="TargetFlow"
                            type="scatterLine"
                            dashType="dot"
                            data={chart2Data?.series?.[10]?.data}
                            xField="capacity"
                            yField="head"
                            color="#006633"
                            yAxis="Head"
                            markers={{
                                visible: false,
                            }}
                            width={3}
                            tooltip={{
                                visible: true,
                                format: "#.##",
                                color: "#FFF",
                            }}
                            visibleInLegend={false}
                        />
                        <ChartSeriesItem
                            name="Target"
                            type="scatter"
                            data={chart2Data?.series?.[11]?.data}
                            xField="capacity"
                            yField="head"
                            color="#4d4d4d"
                            yAxis="Head"
                            markers={{
                                visible: true,
                                type: "square",
                                background: "black",
                                size: 10
                            }}
                            width={2.0}
                            dashType="dot"
                            labels={{
                                visible: true,
                                background: "#bfbfbf",
                                border: {
                                    width: 1,
                                    color: "black",
                                },
                                font: "11px calibri",
                            }}
                            tooltip={{
                                visible: true,
                                format: "{0} x {1}",
                                color: "#fff"
                            }}
                            visibleInLegend={false}
                        />
                    </ChartSeries>

                    {/* X Axis */}
                    <ChartXAxis>
                        <ChartXAxisItem
                            name="Capacity"
                            title={{
                                text: `${chart2Data?.xAxis?.title?.text}`,
                                font: "16px Mulish",
                                color: "#fff",
                            }}
                            color="#fff"
                            axisCrossingValue={chart2Data?.xAxis?.axisCrossingValue}
                            majorGridLines={{ width: 0.8, color: "#A0A0A0" }}
                            minorGridLines={{ width: 0.3, color: "#A0A0A0", visible: true }}
                            crosshair={{
                                visible: true,
                                width: 1,
                                color: "#005F7C",
                                tooltip: {
                                    visible: true,
                                    format: "#.##",
                                },
                            }}
                            min={0}
                            max={chart2Data?.xAxis?.max}
                            majorUnit={chart2Data?.xAxis?.majorUnit}
                        />
                    </ChartXAxis>
                    {/* Y Axis */}
                    <ChartYAxis>
                        <ChartYAxisItem
                            name="Head"
                            title={{
                                text: `${chart2Data?.yAxis?.[0]?.title?.text}`,
                                font: "16px Mulish",
                                color: "#0000FF",
                            }}
                            min={0}
                            max={chart2Data?.yAxis?.[0]?.max}
                            majorUnit={chart2Data?.yAxis?.[0]?.majorUnit}
                            color="#0000FF"
                            majorGridLines={{ width: 0.8, color: "#A0A0A0" }}
                            minorGridLines={{ width: 0.3, color: "#A0A0A0", visible: true }}
                            crosshair={{ visible: true, width: 1, color: "#005F7C" }}
                        />
                    </ChartYAxis>

                    {/* Tooltip */}
                    <ChartTooltip
                        visible={true}
                        color="#FFF"
                        opacity={1.0}
                        format="Flow= #: value.x # , Head= #: value.y #"
                        render={(props: any) => {
                            const x = props?.point?.value?.x?.toFixed(2);
                            const y = props?.point?.value?.y?.toFixed(2);                        
                            return (
                                <div>{x}, {y}</div>
                            );
                        }}
                    />
                </Chart>
            )}
        </div>
    );
};

export default HeadCurve;
